import { render, staticRenderFns } from "./ReferralProgramPrograms.vue?vue&type=template&id=2c6583ea&scoped=true&"
import script from "./ReferralProgramPrograms.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramPrograms.vue?vue&type=script&lang=js&"
import style0 from "./ReferralProgramPrograms.vue?vue&type=style&index=0&id=2c6583ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6583ea",
  null
  
)

export default component.exports